import documentReady from "../helpers/documentReady.js";

documentReady(() => {
  const flash = document.getElementsByClassName('alert')[0];

  if (flash) {
    setTimeout(() => {
      flash.remove()
    }, 5000);
  }
});


